import { disableScroll, enableScroll } from "../wcl-helpers";

document.addEventListener('DOMContentLoaded', () => {
	const burger = document.querySelector('.wcl-header .menu-burger');
	const menu = document.querySelector('.wcl-header-menu');

	/** Mobile menu */
	if ( burger && menu ) {
		burger.addEventListener('click', e => {
			e.preventDefault();

			if ( menu.classList.contains('show') ) {
				menu.classList.remove('show');
				burger.innerHTML = '<i class="fas fa-align-justify"></i>';

				enableScroll();
			} else {
				menu.classList.add('show');
				burger.innerHTML = '<i class="far fa-window-close"></i>';

				disableScroll();
			}
		})
	}

	/** Mobile submenu */
	const menuItemHasChildren = document.querySelectorAll('.menu-item-has-children');

	menuItemHasChildren.forEach(item => {
		const menuArrow = item.querySelector('.menu-arrow');

		menuArrow.addEventListener('click', e => {
			e.preventDefault();
			e.stopPropagation();

			item.classList.toggle('active');
		})
	});
});
